import {
    DELETE_MEMBERSHIP_POOL_SUCCESS,
    FETCH_MEMBERSHIP_POOL,
    FETCH_MEMBERSHIP_POOL_FAILURE,
    FETCH_MEMBERSHIP_POOL_SUCCESS,
    FETCH_MEMBERSHIP_POOLS,
    FETCH_MEMBERSHIP_POOLS_FAILURE,
    FETCH_MEMBERSHIP_POOLS_SUCCESS,
    MEMBERSHIP_POOLS_LIST_FILTER_UPDATE,
    MEMBERSHIP_POOLS_LIST_PAGE,
    MEMBERSHIP_POOLS_LIST_SORT,
    SORT_ASC,
} from 'store/actions/types';

import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';
import paginationHelper from 'helpers/pagination';

const initialState = {
    data: {},
    field: 'name',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_ASC,
    page: 1,
    size: 12,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_MEMBERSHIP_POOL:
        case FETCH_MEMBERSHIP_POOLS:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_MEMBERSHIP_POOL_FAILURE:
        case FETCH_MEMBERSHIP_POOLS_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });

        case FETCH_MEMBERSHIP_POOL_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: action.response,
                }),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
                loading: false,
            });

        case FETCH_MEMBERSHIP_POOLS_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.response.results, (value) => {
                return value.id;
            });

            const newIds = action.response.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.response.offset,
                size: action.response.size,
                total: parseInt(action.response.total, 10),
            });

        case DELETE_MEMBERSHIP_POOL_SUCCESS:
            const {
                id,
            } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);
            const deletedStateIds = reducerHelper.removeItemFromArrayOfStrings(state.ids, id);

            return Object.assign({}, state, {
                data: deletedData,
                ids: deletedStateIds,
                loading: false,
                total: state.total - 1,
            });

        case MEMBERSHIP_POOLS_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case MEMBERSHIP_POOLS_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        case MEMBERSHIP_POOLS_LIST_FILTER_UPDATE:
            const normalisedStatePayload = reducerHelper.normaliseState(initialState, action.payload);

            return Object.assign({}, state, normalisedStatePayload);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/membershipPoolsReducer.js